import React from 'react';
import { useSetResolved } from 'src/core/engine/router';
import { Pricing } from 'src/components/Pricing/Pricing';

import '../../scss/_root-component.scss';

export const PricingRoot: React.FC = () => {
    useSetResolved();

    return <Pricing />;
};

export default PricingRoot;
